import { useAction } from 'shared/hooks/redux/hooks';
import { getUserIssues } from 'entities/support.chat/model/actions';
import { useNavigateTo } from 'shared/hooks/router';
import { useCallback } from 'react';
export function useOpenSupportChat() {
    const requestAllIssues = useAction(getUserIssues);
    const _openChat = useNavigateTo('/support/list');
    const openChat = useCallback(() => {
        _openChat();
        requestAllIssues();
    }, []);
    return openChat;
}
